import { useCompose } from "../context";

/** Returns true if any of the initial compose state has been changed */
export const useIsComposing = () => {
    const { isComposing } = useCompose();

    return isComposing;
};
